import {GroupQueryServiceClient} from 'gabi-api-ts/v2/group/query/group_query.client';
import styled from 'styled-components';

import LoadingView from '@/components/static/loading-view';
import { useBackendQuery } from '@/hooks/use-backend-query';
import {colorPalette} from '@/themes/darkmode';

type GroupQrCodeProps = {
    groupId: string;
    forceLoading: boolean;
}

function uint8ToBase64(uint8Array: Uint8Array) {
    let binary = '';
    const chunkSize = 0x8000; // avoid stack overflow on large arrays
    for (let i = 0; i < uint8Array.length; i += chunkSize) {
        const chunk = uint8Array.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk as unknown as number[]);
    }
    return btoa(binary);
}

function GroupQrCode({forceLoading, groupId}: GroupQrCodeProps) {
    const [qrCodeLoading, qrCode, qrCodeError] = useBackendQuery({
        serviceClient: GroupQueryServiceClient,
        query: GroupQueryServiceClient.prototype.getLatestQrCode,
        data: {
            id: groupId,
        },
        disabled: forceLoading,
        memoize: true,
        grpcOptions: {
            muteErrors: true,
        }
    });

    if (forceLoading || qrCodeLoading) {
        return (
            <StyledWrapper>
                <LoadingView />
            </StyledWrapper>
        );
    }

    // @ts-expect-error code field is there
    const errCode = qrCodeError?.code;
    if (errCode === 'NOT_FOUND') {
        return (
            <StyledWrapper>
                No QR Code
            </StyledWrapper>
        );
    }

    const b64encoded = (qrCode?.qrCodeData) ? uint8ToBase64(qrCode?.qrCodeData) : '';

    return (
        <StyledWrapper>
            <img
                src={`data:image/jpeg;base64,${b64encoded}`}
                alt="qr-code"
            />
        </StyledWrapper>
    );
}

//language=SCSS
const StyledWrapper = styled.div`
& {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${colorPalette.secondBackground};
    aspect-ratio: 1;
    width: 200px;
}
`;

export { GroupQrCode };
